import React from 'react'
import { DisplayText, Caption, Image } from './../../components'
import PropTypes from 'prop-types'
import { getFullAddressForProperty } from '../../utils/property'
import * as translationService from './../../services/translationService'
import styles from './PropertyBar.scss'
import defaultPropertyImage from './../../assets/images/defaultPropertyImage.png'
import { isEmpty } from 'ramda'

const PropertyBar = props => {
  const { property = {} } = props
  const inline = props.inline || false
  const { broker, images } = property

  return isEmpty(property) ? null : (
    <div className={inline ? styles.PropertyBarInline : styles.PropertyBar}>
      {!inline && <Image className={styles.Image} source={(images && images[0]) || defaultPropertyImage} />}

      {property &&
        getFullAddressForProperty(property).length > 0 && (
          <div className={styles.Info}>
            <DisplayText size="ExtraSmall">{getFullAddressForProperty(property)}</DisplayText>
            <Caption>
              {translationService.loginPropertyRef()} {property.reference}
            </Caption>
          </div>
        )}

      {broker &&
        broker.splashUrl && (
          <div className={styles.Logo}>
            <Image className={styles.BrokerImage} source={broker.splashUrl} />
          </div>
        )}
    </div>
  )
}
PropertyBar.propTypes = {
  property: PropTypes.object,
  inline: PropTypes.bool,
}

export default PropertyBar



// WEBPACK FOOTER //
// ./src/components/PropertyBar/PropertyBar.js